import { Breakpoints, TypographyStyle } from "@mui/material/styles";
import { FONT_WEIGHTS } from "./fontWeights";

const createResponsiveTypography = (
    mobile: string,
    tablet: string,
    desktop: string,
    breakpoints: Breakpoints,
    fontWeight?: number | string,
    lineHeight?: number | string
): TypographyStyle => ({
    fontSize: mobile,
    [breakpoints.up("md")]: {
        fontSize: tablet,
    },
    [breakpoints.up("lg")]: {
        fontSize: desktop,
    },
    ...(fontWeight && { fontWeight }),
    ...(lineHeight && { lineHeight }),
});

const createTextVariant = (
    mobile: string,
    tablet: string,
    desktop: string,
    breakpoints: Breakpoints,
    fontWeight?: number | string,
    lineHeight?: number | string
): TypographyStyle => ({
    ...createResponsiveTypography(mobile, tablet, desktop, breakpoints, fontWeight, lineHeight),
});

export const createTypography = (breakpoints: Breakpoints) => ({
    fontFamily: "Circular",
    fontWeight: FONT_WEIGHTS,
    fontWeightLight: FONT_WEIGHTS.light,
    fontWeightRegular: FONT_WEIGHTS.default,
    fontWeightMedium: FONT_WEIGHTS.medium,
    fontWeightBold: FONT_WEIGHTS.bold,
    h1: createResponsiveTypography("28px", "32px", "38px", breakpoints, FONT_WEIGHTS.default),
    h2: createResponsiveTypography("26px", "30px", "32px", breakpoints, FONT_WEIGHTS.default),
    h3: createResponsiveTypography("24px", "28px", "28px", breakpoints, FONT_WEIGHTS.default),
    h4: createResponsiveTypography("20px", "24px", "24px", breakpoints, FONT_WEIGHTS.default),
    h5: createResponsiveTypography("18px", "20px", "20px", breakpoints, FONT_WEIGHTS.default),
    h6: createResponsiveTypography("16px", "18px", "18px", breakpoints, FONT_WEIGHTS.default),
    large: createTextVariant("18px", "18px", "18px", breakpoints, FONT_WEIGHTS.light, 1.5),
    normal: createTextVariant("16px", "16px", "16px", breakpoints, FONT_WEIGHTS.light, 1.5),
    small: createTextVariant("14px", "14px", "14px", breakpoints, FONT_WEIGHTS.light, 1.5),
});
